import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../context.js';

import { Button } from '../components/component.js';

import Background from '../../files/background.png';
import LogoDark from '../../files/logo-dark.png';

function Forget() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [email, setEmail] = useState('');

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  function onClickSendReset() {
    let u = context.addSpiner();
    axios.post('/api/public/forgot-password', {
      email: email
    }).then((r) => {
      setSuccess(true);
      setError(null);
    }).catch((e) => {
      if (e.response && e.response.data && e.response.data.error) {
        setError(e.response.data.error);
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  return (
    <div className="d-flex justify-content-between align-items-center h-100 w-100" style={{backgroundColor: '#11254F'}}>
              
      <div className="d-flex justify-content-center align-items-center w-100">
        <div style={{width: 400, paddingBottom: '15%'}}>
          <img src={LogoDark} className="w-50 mb-4" />

          <div className="typo-strong-300" style={{color: "white"}}>Forgot your password?</div>

          <div className="typo-medium-150 mb-4" style={{color: "white"}}>Enter your username and we'll send you instructions to reset your password</div>

          {!success ? (
            <>
              <div className="typo-normal-125 mb-1" style={{color: "white"}}>Username</div>
              <input 
                type="text" 
                placeholder="Enter your username" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                className="input w-100 mb-4" 
              />
            
              <Button color="blue" text="Send Reset Instructions" onClick={onClickSendReset} className="w-100 mb-3" />

              <div className="w-100 text-center">
                <button 
                  onClick={() => navigate("/")} 
                  className="typo-normal-125"
                  style={{
                    background: "none", 
                    border: "none", 
                    color: "#87CEEB", 
                    textDecoration: "underline",
                    cursor: "pointer"
                  }}
                >
                  Back to Login
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="typo-medium-150 mb-4" style={{color: "#4CAF50"}}>
                Reset instructions have been sent to your email address.
              </div>
              
              <Button color="blue" text="Back to Login" onClick={() => navigate("/")} className="w-100" />
            </>
          )}

          <div className="mt-2 w-100 text-center" style={{height: 24}}>
            <div className="typo-strong-150 mt-2" style={{color: "white"}}>{error ? error : ""}</div>
          </div>

        </div>
      </div>
      <img src={Background} className={(context.scale === "lg" || context.scale === "xs" || context.scale === "xxl") ? "h-100" : context.scale === "md" ? "h-75" : "d-none"} />
    </div>
  );
}

export default Forget;
